// Action constants for ORM
export const FETCH_START = 'orm/FETCH_START'
export const FETCH_SUCCESS = 'orm/FETCH_SUCCESS'
export const FETCH_ERROR = 'orm/FETCH_ERROR'
export const DELETE_START = 'orm/DELETE_START'
export const DELETE_SUCCESS = 'orm/DELETE_SUCCESS'
export const DELETE_ERROR = 'orm/DELETE_ERROR'
export const PATCH_START = 'orm/PATCH_START'
export const PATCH_SUCCESS = 'orm/PATCH_SUCCESS'
export const PATCH_ERROR = 'orm/PATCH_ERROR'
export const POST_START = 'orm/POST_START'
export const POST_SUCCESS = 'orm/POST_SUCCESS'
export const POST_ERROR = 'orm/POST_ERROR'
export const CHANGE = 'orm/CHANGE'
export const PENDING_REQUEST = 'orm/PENDING_REQUEST'
export const RESET = 'orm/RESET'

// actions dispatched from data table
export const TOGGLE_SELECT = 'orm/TOGGLE_SELECT'
export const SET_SELECTION = 'orm/SET_SELECTION'
export const RESET_META = 'orm/RESET_META'

// actions that trigger user interaction
export const TRASH = 'orm/TRASH'
